export const blockIconsImageAdjust = (
	<span className='material-symbols-outlined'>adjust</span>
);
